import Splide from '@splidejs/splide';

const EL = '.js-gallery-carousel';
const ACTIVE_CLASS = 'is-active';

if (document.querySelector(EL)) {
  const slider = new Splide(EL, {
    pagination: false,
    arrows: true,
    perPage: 3,
    perMove: 1,
    gap: 20,
    breakpoints: {
      768: {
        perPage: 1
      }
    }
  }).mount();
}
